import * as TransferItemsHelper from '@app/helper/transfer-items';

import FileEntry from './file-entry';
import { REGEXP_EMAIL_LABEL } from './config';

// This is a list of all legacy expiry options,
// in the new site we will only display: 1w, 2w, 1m, never
const expiryOptions = {
  '1d': 60 * 60 * 24,
  '2d': 60 * 60 * 24 * 2,
  '3d': 60 * 60 * 24 * 3,
  '1w': 60 * 60 * 24 * 7,
  '2w': 60 * 60 * 24 * 14,
  '1m': 60 * 60 * 24 * 30,
  '2m': 60 * 60 * 24 * 60,
  '3m': 60 * 60 * 24 * 90,
  '6m': 60 * 60 * 24 * 180,
  '1y': 60 * 60 * 24 * 365,
  never: 0,
};

export function convertExpiry(seconds) {
  if (typeof seconds === 'string') {
    return expiryOptions[seconds];
  }

  for (const name in expiryOptions) {
    if (expiryOptions[name] === seconds) {
      return name;
    }
  }

  return false;
}

export function extractEmails(input) {
  // Clean-up input
  input = input.replace(/^\s+|\s+$/g, ''); // trim string
  input = input.replace(/\s+/g, ' '); // convert multispace in 1 space

  // Split multiple
  let addresses = input.split(/\s*,\s*|\s*;\s*|\s+/);

  // Filter out bad ones
  addresses = addresses.filter((email) => !!email.match(REGEXP_EMAIL_LABEL));

  // Get only the email, not the labels.
  return addresses.map((email) => {
    const result = email.match(REGEXP_EMAIL_LABEL);

    if (result[3]) {
      return result[3];
    }
    return result[6];
  });
}

export function mapToSpaceship(transfer) {
  transfer.description = transfer.description || transfer.message;

  const files = transfer.files || transfer.items || []; // Let's save the files array

  if (transfer.state === 'init' || (transfer.files && !transfer.items)) {
    transfer.items = transfer.files.map((file) => {
      file.apiType = file.apiType || file.item_type;

      return {
        id: file.id,
        content_identifier: 'file',
        name: file.name,
        size: file.size,
        downloadable: true,
        previewable: file.previewable,
        apiType: file.apiType,
        file: new FileEntry(file),
      };
    });
  }

  transfer.items = TransferItemsHelper.getItemsWithUITypes(transfer.items);
  transfer.itemsTree = TransferItemsHelper.buildItemsTree(transfer.items);
  transfer.files = files;

  transfer.title = transfer.display_name;
  /*
   * items (and files) can be empty when this function is called from the
   * Files#render (components/transfer/uploader/files.es6)
   * this is also the case if the transfer is password protected
   * */
  if (!transfer.title && transfer.items.length) {
    transfer.title = TransferItemsHelper.getSubNodesFromItemName(
      transfer.items[0].name
    ).pop();
  }

  return transfer;
}

export default function buildparams(transfer) {
  if (transfer.files) {
    transfer = mapToSpaceship(transfer);
  }

  let params = {
    recipients: transfer.recipients,
    message: transfer.message,
    from: transfer.sender,
  };

  // Throw away email params if not an e-mail transfer.
  if (transfer.type !== 'email') {
    params = {
      message: transfer.message,
    };
  }

  // Only do plus features if we are there
  if (transfer.userType === 'plus') {
    if (transfer.password) {
      params['password'] = transfer.password;
    }

    if (transfer.expiry && expiryOptions[transfer.expiry]) {
      params['expire_in'] = expiryOptions[transfer.expiry];
    }
  }

  // Are we using a channel?
  if (transfer.channel) {
    params['channel'] = transfer.channel;
  }

  // Do we have a language?
  if (transfer.language) {
    params['ui_language'] = transfer.language;
  }

  if (transfer.domain_user_id) {
    params['domain_user_id'] = transfer.domain_user_id;
  }

  // Is this a forward? (Forwards don't need filenames)
  if (transfer.parent_id) {
    params['parent_id'] = transfer.parent_id;
  } else {
    params['files'] = transfer.files.map((file) => ({
      name: file.name,
      size: file.size,
      item_type: file.apiType,
    }));
  }

  // Do we have an account id? (Account entity was added in v4 API)
  if (transfer.accountId) {
    params['account_id'] = transfer.accountId;
  }

  return params;
}
